import { useRef, useCallback } from "react";

type SwipeCallback = () => void;

export function useSwipe({
	onSwipeLeft, 
	onSwipeRight, 
	threshold = 50
}: {
	onSwipeLeft?: SwipeCallback,
	onSwipeRight?: SwipeCallback,
	threshold?: number,
}) {
	const startX = useRef<number | null>(null);

	const start = useCallback((x: number) => {
		startX.current = x;
	}, []);

	const end = useCallback(
		(x: number) => {
			if (startX.current === null) return;
			const deltaX = x - startX.current;
			/* if (deltaX > threshold) {
				onSwipeRight();
			} */
		if (deltaX > threshold && onSwipeRight) {
			onSwipeRight();
		} else if (deltaX < -threshold && onSwipeLeft) {
			onSwipeLeft();
		}
			startX.current = null;
		},
		[onSwipeRight, threshold]
	);

	const onTouchStart = useCallback(
		(e: React.TouchEvent) => {
			start(e.touches[0].clientX);
		},
		[start]
	);

	const onTouchEnd = useCallback(
		(e: React.TouchEvent) => {
			end(e.changedTouches[0].clientX);
		},
		[end]
	);

	const onMouseDown = useCallback(
		(e: React.MouseEvent) => {
			start(e.clientX);
		},
		[start]
	);

	const onMouseUp = useCallback(
		(e: React.MouseEvent) => {
			end(e.clientX);
		},
		[end]
	);

	return {
		onTouchStart,
		onTouchEnd,
		onMouseDown,
		onMouseUp,
	};
}